export const UNVISITED = 'unvisited-node';
export const VISITED = 'visited-node';
export const START = 'start-node';
export const TARGET = 'target-node';
export const WALL = 'wall-node';
export const WEIGHT = 'weight-node';
export const PATH = 'path-node';